import React, { useEffect } from "react";
import { CustomTable } from "../../../components";
import { userTransactionTableHeading } from "../../../assets/lib/userTransaction";
import { makeStyles } from "@mui/styles";

const customStyle = makeStyles({
  root: {
    padding: "60px 40px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "30px",
  },
  '@media (max-width: 319px)': {
    root: {
      padding: "60px 5px",
      width: "90%",
      display: "flex",
      flexDirection: "column",
      gap: "10px",
    },
  },
  '@media (min-width: 320px) and (max-width: 480px)': {
    root: {
      padding: "60px 5px",
      width: "90%",
      display: "flex",
      flexDirection: "column",
      gap: "10px",
    },
  },
  '@media (min-width: 481px) and (max-width: 768px)': {
    root: {
      padding: "60px 20px",
      width: "95%",
      display: "flex",
      flexDirection: "column",
      gap: "25px",
    },
  },
  '@media (min-width: 769px) and (max-width: 1024px)': {
    root: {
      padding: "70px 30px",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: "30px",
    },
  },
});

const Layout = (props) => {
  const {
    userTransactionData,
    isTableLoading,
    currentPage,
    totalLength,
    handlePageChange,
    handlePageSize,
    handleSearchQuery,
    handleTableSorting,
    actions, // ✅ RECEIVE ACTIONS
  } = props;

  const classes = customStyle();

  useEffect(() => {
    console.log("[DEBUG][Layout] Props received:", {
      isTableLoading,
      currentPage,
      totalLength,
      userTransactionData,
    });
  }, [userTransactionData, isTableLoading, currentPage, totalLength]);

  return (
    <div className={classes.root}>
      <CustomTable
        columns={userTransactionTableHeading}
        data={userTransactionData}
        isLoading={isTableLoading}
        currentPage={currentPage}
        totalLength={totalLength}
        handlePageChange={handlePageChange}
        handlePageSize={handlePageSize}
        handleTableSorting={handleTableSorting}
        actions={actions}  // ✅ PASS ACTIONS TO CUSTOM TABLE
      />
    </div>
  );
};

export default Layout;
